import { AsyncHotelFilterMenu } from './AsyncHotelFilterMenu'
import { AsyncHotelFilterSelect } from './AsyncHotelFilterSelect'

export const AsyncHotelFilter = {
  Select: AsyncHotelFilterSelect,
  Menu: AsyncHotelFilterMenu,
}
